import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bundle-lines',
  templateUrl: './bundle-lines.component.html',
  styleUrls: ['./bundle-lines.component.scss']
})
export class BundleLinesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
